import React from 'react';
import { useNavigate } from 'react-router-dom';
import AppExcelUploadView from '../../../components/AppExcelUploadView';
import { manualPunchApi } from './api/manualPunchApi';
import { appToast } from '../../../components/AppToast';

export default function ManualPunchBulkUploadScreen() {
  const navigate = useNavigate();

  const handleDownloadSample = async () => {
    try {
      await manualPunchApi.downloadTemplate();
      appToast.success('Manual Punch template downloaded successfully.');
    } catch (err) {
      console.error(err);
      appToast.error('Failed to download manual punch template.');
    }
  };

  const handleUpload = async (file) => {
    try {
      const result = await manualPunchApi.uploadBulk(file);
      if (result.failed_count > 0 && result.imported_count === 0) {
        const firstErr = result.errors?.[0] || 'Bulk upload failed.';
        appToast.error(firstErr);
        throw new Error(firstErr);
      } else if (result.failed_count > 0) {
        appToast.warning(
          `Imported ${result.imported_count} punches with ${result.failed_count} errors. Check console or list for details.`
        );
      } else {
        appToast.success(result.message || 'All manual punches imported successfully!');
      }
      navigate('/payroll/manual-punch');
    } catch (err) {
      const detail = err?.response?.data?.detail || err?.message || 'Failed to upload manual punch spreadsheet.';
      appToast.error(detail);
      throw err;
    }
  };

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-16">
      {/* ── Page Header Canopy ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">
            Attendance Regularization
          </p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Bulk Upload Manual Punches
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Import employee manual punch regularization requests via standardized Excel spreadsheet.
          </p>
        </div>
      </section>

      {/* ── Shared 3-Step Excel Importer ── */}
      <AppExcelUploadView
        title="Upload Manual Punches"
        subtitle="Bulk import employee attendance regularization punches using Excel."
        description="Use this option to upload manual punches using Excel sheets in 3 simple steps. Download the sample template, fill in the details, and upload the file. Please make sure that all Employee ID Card numbers and Reasons match the master data."
        sampleFileName="Manual_Punch_Template.xlsx"
        onDownloadSample={handleDownloadSample}
        onUpload={handleUpload}
        cancelPath="/payroll/manual-punch"
        backLabel="Back to Manual Punch List"
        masterRequirements={[
          'Name (Employee Name or ID Card No)',
          'Date (YYYY-MM-DD)',
          'Intime (HH:MM 24hr format)',
          'OutTime (HH:MM 24hr format)',
          'Reason (e.g. Card Forgot / Lost, Machine / Scanner Issue, Other)',
          'Remarks (Mandatory if Reason is Other)',
        ]}
      />

    </div>
  );
}
